export enum NotificationActionType {
  Reload = 'reload',
  Close = 'close'
}

export interface Notification {
  id: string
  message: string
  actionType?: NotificationActionType
  autoCloseTime?: number
}

export interface NotificationsState {
  items: Notification[]
}
